import { BuildingOffice2Icon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { Link } from '../util/router';
import ProfilePhoto from './ProfilePhoto';

export function OrgCard({ org }) {
  return (
    <Link
      to={`/org/${org.org_id}`}
      className="flex items-center gap-4 rounded-xl border border-slate-200 bg-white px-4 py-4 transition-colors hover:border-slate-300 hover:bg-slate-50"
    >
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-100">
        <BuildingOffice2Icon className="h-6 w-6 text-slate-600" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-lg font-medium uppercase text-slate-900">
          {org.org_name || 'Unknown venue'}
        </p>
        {org.neighborhoods?.length > 0 && (
          <p className="truncate text-sm text-slate-500">{org.neighborhoods.join(', ')}</p>
        )}
      </div>
      <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400" />
    </Link>
  );
}

export function UserCard({ user }) {
  return (
    <Link
      to={`/profile/${user.username}`}
      className="flex items-center gap-4 rounded-xl border border-slate-200 bg-white px-4 py-4 transition-colors hover:border-slate-300 hover:bg-slate-50"
    >
      <ProfilePhoto userId={user.id} isSettings={false} small />
      <div className="min-w-0 flex-1">
        <p className="truncate font-medium text-slate-900">@{user.username || 'unknown'}</p>
        {user.name && <p className="truncate text-sm text-slate-500">{user.name}</p>}
      </div>
      <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400" />
    </Link>
  );
}
